import { useEffect, useState } from 'react';
import { useDebounceCallback } from '@react-hook/debounce';
import get from 'lodash/get';
import {
  convertMetricsNameToV3,
  getDashboardMetricsV3
} from 'common/services/metrics.service';
import { getAggregatedMetrics } from './AllContributorsDoraDashboard.formatter';

const useMetrics = ({
  dates,
  metricsCalculationStrategy,
  selectedTeamId,
  roll_up = 'custom',
  widgetsMetricsNames,
  isAggregatedMetrics = false,
  fetchDependency = null
}) => {
  const [metrics, setMetrics] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleFetchErrors = e => {
    return get(e, 'response.data.description', '');
  };

  const fetchMetrics = async () => {
    try {
      const res = await getDashboardMetricsV3({
        time_ranges: [{ after: dates.from, before: dates.to }],
        requested_metrics: convertMetricsNameToV3(
          isAggregatedMetrics
            ? getAggregatedMetrics(widgetsMetricsNames)
            : widgetsMetricsNames,
          metricsCalculationStrategy
        ),
        offset: 0,
        return_no_data: true,
        roll_up
      });

      setMetrics(res);
    } catch (e) {
      handleFetchErrors(e);
    }
    setIsLoading(false);
  };

  const debouncedFetchMetrics = useDebounceCallback(fetchMetrics, 800);

  useEffect(() => {
    setIsLoading(true);
    debouncedFetchMetrics();
  }, [dates?.from, dates?.to, selectedTeamId, fetchDependency]);

  return {
    metrics,
    isLoading
  };
};

export default useMetrics;
